var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlinePaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#E6EEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 35C25 32.2386 27.2386 30 30 30L70 30C72.7614 30 75 32.2386 75 35V65C75 67.7614 72.7614 70 70 70H30C27.2386 70 25 67.7614 25 65L25 35ZM70 35L30 35V65H70V35Z",
    fill: "#0050AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 44.0002C25 42.6195 26.1193 41.5002 27.5 41.5002H72.5C73.8807 41.5002 75 42.6195 75 44.0002C75 45.381 73.8807 46.5002 72.5 46.5002H27.5C26.1193 46.5002 25 45.381 25 44.0002Z",
    fill: "#0050AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 55C35 53.6193 36.1193 52.5 37.5 52.5H42.5C43.8807 52.5 45 53.6193 45 55C45 56.3807 43.8807 57.5 42.5 57.5H37.5C36.1193 57.5 35 56.3807 35 55Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePaymentIcon);
export default __webpack_public_path__ + "static/media/online_payment_icon.0bdda86e60ad32f9bc495c1121bd217f.svg";
export { ForwardRef as ReactComponent };